import { quickQuotesLeadFormRoutes } from './quick-quotes-lead-form';
import { configuratorLeadFormRoutes } from './configurator-lead-form';
import { shoppingRoutes } from './shopping';

export const routes = [...quickQuotesLeadFormRoutes, ...configuratorLeadFormRoutes, ...shoppingRoutes];
